import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { rutaInicio } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/marca/Logo";
import { Loader2 } from "lucide-react";
import { IdiomaSelector } from "@/components/IdiomaSelector";
import { t } from "@/lib/i18n";

function PatronContenedores() {
  const filas = [[0, 1, 2], [0.5, 1.5], [0, 1, 2]];
  return (
    <svg viewBox="0 0 360 200" className="w-full max-w-md" fill="none" stroke="#35557B" strokeWidth="1.4" aria-hidden="true">
      {filas.map((f, r) => f.map((c, i) => {
        const x = 10 + c * 112, y = 130 - r * 58 + (r === 1 ? 0 : 0);
        return (
          <g key={`${r}-${i}`}>
            <rect x={x} y={y} width="108" height="52" rx="2" />
            {Array.from({ length: 11 }).map((_, k) => <path key={k} d={`M${x + 8 + k * 9} ${y + 4}V${y + 48}`} />)}
          </g>
        );
      }))}
    </svg>
  );
}

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={rutaInicio(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(usuario.trim(), password);
      navigate(u.debe_cambiar_password ? "/cambiar-password" : rutaInicio(u), { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-paper">
      <aside className="bg-navy lg:w-[40%] lg:min-h-screen flex flex-col justify-between p-6 lg:p-12" data-testid="login-panel-marca">
        <div>
          <IdiomaSelector claro className="mb-5" />
          <Logo light size={36} />
        </div>
        <div className="my-8 lg:my-0">
          <h2 className="font-display font-bold text-white text-[28px] lg:text-[44px] leading-[1.05]">{t("Cada contenedor, en su lugar.")}</h2>
          <p className="hidden lg:block mt-4 text-[#C4D0E0] text-[17px] max-w-sm">{t("Cargas, choferes y papeles de Leonas Group en una sola plataforma.")}</p>
        </div>
        <div className="hidden lg:block"><PatronContenedores /></div>
      </aside>
      <main className="flex-1 flex items-start lg:items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-[380px]">
          <h1 className="font-display font-bold text-[30px] leading-[1.05] text-navy-2">{t("Entrar")}</h1>
          <p className="text-ink-3 mt-1.5 mb-6">{t("Usa el usuario que te dio la oficina.")}</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="usuario">{t("Usuario")}</Label>
              <Input id="usuario" data-testid="login-usuario-input" value={usuario} onChange={(e) => setUsuario(e.target.value)} autoCapitalize="none" autoCorrect="off" className="mt-1.5 h-12" required />
            </div>
            <div>
              <Label htmlFor="password">{t("Contraseña")}</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12" required />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-danger font-medium">{error}</p>}
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-[50px] text-base">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : t("Entrar")}
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
}
